export let Identifiers = /*#__PURE__*/function (Identifiers) {
  Identifiers["ANALYTICS_ANONYMOUS_ID"] = "analyticsAnonymousId";
  Identifiers["ATLASSIAN_ACCOUNT_ID"] = "atlassianAccountId";
  Identifiers["ATLASSIAN_ORG_ID"] = "atlassianOrgId";
  Identifiers["TENANT_ID"] = "tenantId";
  Identifiers["TRELLO_ANONYMOUS_ID"] = "trelloAnonymousId";
  Identifiers["TRELLO_USER_ID"] = "trelloUserId";
  Identifiers["FF_CLIENT_ANONYMOUS_ID"] = "ffClientAnonymousId";
  return Identifiers;
}({});

/**
 * Reasons from a FeatureFlag evaluation to explain the value provided.
 *
 * By default it uses 'OFF' = 0, which consider 0 in EvaluationReason and '0' in EvaluationReason
 * are valid EvaluationReason value
 * We set the enum value to string thus it can perform proper 'reason in EvaluationReason' check
 *
 */
export let EvaluationReason = /*#__PURE__*/function (EvaluationReason) {
  EvaluationReason["OFF"] = "OFF";
  EvaluationReason["FALLTHROUGH"] = "FALLTHROUGH";
  EvaluationReason["RULE_MATCH"] = "RULE_MATCH";
  EvaluationReason["TARGET_MATCH"] = "TARGET_MATCH";
  EvaluationReason["PREREQUISITE_FAILED"] = "PREREQUISITE_FAILED";
  EvaluationReason["ERROR"] = "ERROR";
  EvaluationReason["INELIGIBLE"] = "INELIGIBLE";
  EvaluationReason["OVERRIDE"] = "OVERRIDE";
  return EvaluationReason;
}({});

/**
 * The error kind when there is a problem evaluating a FeatureFlag
 */
export let EvaluationErrorKind = /*#__PURE__*/function (EvaluationErrorKind) {
  EvaluationErrorKind["CLIENT_NOT_READY"] = "CLIENT_NOT_READY";
  EvaluationErrorKind["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
  EvaluationErrorKind["WRONG_TYPE"] = "WRONG_TYPE";
  EvaluationErrorKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  EvaluationErrorKind["SERVER_ERROR"] = "SERVER_ERROR";
  EvaluationErrorKind["OTHER"] = "OTHER";
  return EvaluationErrorKind;
}({});

/**
 * Types of feature flag values we support.
 */

/**
 * JSON map of additional data that can be sent with an exposure event.
 */

/**
 * Options for the getValue or getFlagValue functions.
 */

/**
 * Used for feature flags tracking experiments.
 * This could be available from the FeatureFlag beyond MVP.
 *
 * Provides an explanation to how the value was assigned.
 */

// TODO: Not quite right, this returns the keys of the enum, not the values.
// Would be ideal if we could use the values. Else remove the uppercase keys and use values as keys
// some workaround here https://stackoverflow.com/questions/52393730/typescript-string-literal-union-type-from-enum
// export type IdentifiersObject = {
//   [key in keyof typeof Identifiers]: string;
// };
/**
 * Context specific to the logged in user.
 */
export let ExposureType = /*#__PURE__*/function (ExposureType) {
  ExposureType["OptIn"] = "optInExposure";
  ExposureType["Automatic"] = "autoExposure";
  ExposureType["HasCustomAttributes"] = "hasCustomAttributes";
  return ExposureType;
}({});

/**
 * The analytics-web-client used by the product.
 */

/**
 * Client used to fetch, cache and evaluate flags.
 */

/**
 * TrackingInfo defines the behaviour of how exposures are fired
 * from the client for a particular feature flag.
 *  - samplingRate: An integer representing the rate at which exposure
 *                  events should be emitted. It is represented as 1/x,
 *                  where x >= 0. When x = 0 -> 0%, 1 -> 100%, 2 -> 50% ...
 */

export let EnvironmentType = /*#__PURE__*/function (EnvironmentType) {
  EnvironmentType["LOCAL"] = "local";
  EnvironmentType["DEV"] = "dev";
  EnvironmentType["STAGING"] = "staging";
  EnvironmentType["PROD"] = "prod";
  return EnvironmentType;
}({});
export let PerimeterType = /*#__PURE__*/function (PerimeterType) {
  PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
  return PerimeterType;
}({});
export let ReadyReason = /*#__PURE__*/function (ReadyReason) {
  ReadyReason["CACHE"] = "CACHE";
  ReadyReason["FETCH"] = "FETCH";
  ReadyReason["CLIENT_ERROR"] = "CLIENT_ERROR";
  ReadyReason["SERVER_ERROR"] = "SERVER_ERROR";
  return ReadyReason;
}({});
// Loggers

export let LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
  LogLevel[LogLevel["INFO"] = 2] = "INFO";
  LogLevel[LogLevel["LOG"] = 3] = "LOG";
  LogLevel[LogLevel["WARN"] = 4] = "WARN";
  LogLevel[LogLevel["ERROR"] = 5] = "ERROR";
  return LogLevel;
}({});